import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import { FaBars, FaTimes, FaSearch, FaBook, FaInfoCircle, FaUser, FaSignOutAlt, FaBrain, FaMoon, FaSun } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, currentUser, logout } = useAuth();
  const { darkMode, toggleTheme } = useTheme();
  const dropdownRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  // Handle scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
    setSearchActive(false);
    setDropdownOpen(false);
  }, [location]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className={`site-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
            <span className="logo-text">Reso<span className="logo-highlight">REP</span></span>
          </Link>
        </div>
        
        <div className="header-right">
        {/*   {!isMobile && (
            <div className={`search-container ${searchActive ? 'active' : ''}`}>
              <input 
                type="text" 
                placeholder="Search for resources..." 
                className="search-input"
              />
              <button 
                className="search-toggle" 
                onClick={() => setSearchActive(!searchActive)}
              >
                {searchActive ? <FaTimes /> : <FaSearch />}
              </button>
            </div>
          )} */}
          
          <button 
            className="theme-toggle" 
            onClick={toggleTheme}
            aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
          
          <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </div>
          
          <nav className={`nav-links${isMenuOpen ? " open" : ""}`}>
            {/* {isMobile && (
              <div className={`search-container ${searchActive ? 'active' : ''}`}>
                <input 
                  type="text" 
                  placeholder="Search for resources..." 
                  className="search-input"
                />
                <button 
                  className="search-toggle" 
                  onClick={() => setSearchActive(!searchActive)}
                >
                  {searchActive ? <FaTimes /> : <FaSearch />}
                </button>
              </div>
            )} */}
            
            <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
              Home
            </Link>
            <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
              <FaInfoCircle className="nav-icon" />
              About
            </Link>
            <Link to="/subject" className={location.pathname === '/subject' ? 'active' : ''}>
              <FaBook className="nav-icon" /> Past Papers & Resources
            </Link>
            <Link to="/study-tools" className={location.pathname === '/study-tools' ? 'active' : ''}>
              <FaBrain className="nav-icon" /> Study Tools
            </Link>
            
            {isAuthenticated ? (
              <div className="user-dropdown" ref={dropdownRef}>
                <button 
                  className="dropdown-toggle"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <div className="user-avatar">
                    {currentUser?.name?.charAt(0).toUpperCase() || 'U'}
                  </div>
                  <span className="user-name">{currentUser?.name?.split(' ')[0] || 'User'}</span>
                </button>
                
                {dropdownOpen && (
                  <div className="dropdown-menu">
                    <Link to="/profile" className="dropdown-item">
                      <FaUser className="dropdown-icon" />
                      My Profile
                    </Link>
                    <button onClick={handleLogout} className="dropdown-item">
                      <FaSignOutAlt className="dropdown-icon" />
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="nav-button">
                Sign In
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header; 